import { css } from '@emotion/react'

const style = css`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`
export const Overlay = ({ children }: { children: React.ReactNode }) => {
  return <div css={style}>{children}</div>
}
